import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import { GoogleMap } from '@react-google-maps/api';
import GoogleMapsProvider from '../../../bundles/shared/GoogleMapsProvider';


const MapWithMarker = ({ lat, lon, height = "200px" }) => {
  const [map, setMap] = useState(null);
  const [marker, setMarker] = useState(null);

  const mapContainerStyle = {
    width: '100%',
    height: '100%'
  };

  const center = {
    lat: parseFloat(lat),
    lng: parseFloat(lon)
  };

  const options = {
    zoomControl: false,
    mapTypeControl: false,
    scaleControl: false,
    streetViewControl: false,
    panControl: false,
    rotateControl: false,
    fullscreenControl: false,
    mapId: "MAP_WITH_MARKER"
  };

  useEffect(() => {
    if (!map) return;

    const initMarker = async () => {
      const { AdvancedMarkerElement } = await google.maps.importLibrary("marker");

      if (marker) {
        marker.setMap(null);
      }

      const newMarker = new AdvancedMarkerElement({
        position: new google.maps.LatLng(parseFloat(lat), parseFloat(lon)),
        map
      });

      setMarker(newMarker);
    };

    initMarker();

    return () => {
      if (marker) {
        marker.setMap(null);
      }
    };
  }, [map, lat, lon]);

  return (
    <GoogleMapsProvider>
      <div style={{ height }}>
        <GoogleMap
          mapContainerStyle={mapContainerStyle}
          center={center}
          zoom={15}
          options={options}
          onLoad={setMap}
        />
      </div>
    </GoogleMapsProvider>
  );
};

MapWithMarker.propTypes = {
  lat: PropTypes.string.isRequired,
  lon: PropTypes.string.isRequired,
  height: PropTypes.string
};

export default MapWithMarker;
